<script>
	// NPM Modules
	import { createEventDispatcher } from 'svelte';
	import dayjs from 'dayjs';
	// Components
	import Icon from '@/Components/Icon.svelte';
	import CheckBox from '@/Components/CheckBox.svelte';
	import ACLStore from '@/Stores/ACLStore.js';

	const dispatch = createEventDispatcher();

	export let competitions;
	export let sport;
	export let selectedCompetition;
</script>

<table class="w-full whitespace-nowrap mt-3">
	<thead>
		<tr class="text-xs text-left text-gray-500 uppercase">
			<th class="px-6 pt-3 pb-2 font-medium">Competition</th>
			<th class="w-px px-6 pt-3 pb-2 font-medium text-left">Start Time</th>
			<th class="w-px px-6 pt-3 pb-2 font-medium">Cashout</th>
			<th class="w-px px-6 pt-3 pb-2 font-medium text-left">Fees</th>
			<th class="w-px px-6 pt-3 pb-2 font-medium text-left">EXT ID</th>
			<th class="w-px px-6 pt-3 pb-2 font-medium text-left">Sport</th>
			<th class="w-px px-6 pt-3 pb-2 font-medium text-left">Featured</th>
			{#if $ACLStore && ACLStore.granted('competitions.update')}
				<th class="w-px px-6 pt-3 pb-2 font-medium text-right" />
			{/if}
			<th class="w-px px-6 pt-3 pb-2 font-medium text-right" />
		</tr>
	</thead>
	<tbody class="bg-white">
		{#each competitions as competition (competition.id)}
			<tr class="cursor-pointer hover:bg-gray-100 focus-within:bg-gray-100">
				<td
					class="p-4 px-6 border-t"
					on:click={() => {
						selectedCompetition = competition;
						dispatch('selected');
					}}
				>
					<div class="flex items-center">
						<div class="mr-2 font-semibold">{competition.name}</div>
					</div>
				</td>
				<td
					class="w-px px-6 border-t text-right"
					on:click={() => {
						selectedCompetition = competition;
						dispatch('selected');
					}}
				>
					{competition.start_time ? dayjs(competition.start_time).format('D MMM YYYY, HH:mm') : ''}
				</td>
				<td
					class="w-px px-6 border-t"
					on:click={() => {
						selectedCompetition = competition;
						dispatch('selected');
					}}
				>
					<div class="flex flex-row items-center justify-center">
						<CheckBox disabled bind:checked={competition.cashout_enabled} />
					</div>
				</td>
				<td
					class="w-px px-6 border-t text-right"
					on:click={() => {
						selectedCompetition = competition;
						dispatch('selected');
					}}
				>
					{competition.fees ? competition.fees + '%' : '-'}
				</td>
				<td
					class="w-px px-6 border-t"
					on:click={() => {
						selectedCompetition = competition;
						dispatch('selected');
					}}
				>
					{#if competition.remote_id}
						<div class="px-2 py-1 bg-blue-500 rounded-md text-light text-center">
							{competition.remote_id}
						</div>
					{:else if competition.is_manual}
						<div class="px-2 py-1 bg-orange-500 rounded-md text-light">MANUAL</div>
					{/if}
				</td>
				<td
					class="w-px px-6 border-t text-right"
					on:click={() => {
						selectedCompetition = competition;
						dispatch('selected');
					}}
				>
					<div class="px-2 py-1 bg-green-500 rounded-md text-light">
						{sport.name}
					</div>
				</td>
				<td
					class="w-px px-6 border-t"
					on:click={() => {
						selectedCompetition = competition;
						dispatch('selected');
					}}
				>
					<CheckBox disabled bind:checked={competition.featured} />
				</td>
				{#if $ACLStore && ACLStore.granted('competitions.update')}
					<td class="w-px px-6 border-t">
						<button
							class="btn btn-black"
							on:click={() => {
								selectedCompetition = competition;
								dispatch('sportcast');
							}}>Remap sportcast</button
						>
					</td>
				{/if}
				<td
					class="w-px px-6 border-t"
					on:click={() => {
						selectedCompetition = competition;
						dispatch('selected');
					}}
				>
					<Icon name="chevron-right" classes="block w-4 h-4 text-gray-400 inline" />
				</td>
			</tr>
		{:else}
			<tr>
				<td
					class="px-6 py-4 text-center border-t"
					colspan={$ACLStore && ACLStore.granted('competitions.update') ? 9 : 8}
				>
					No competitions found for {sport.name}.
				</td>
			</tr>
		{/each}
	</tbody>
</table>
